<template>
    <div>
        <Card>
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <transition name="fade">
                <Row v-if="mainTable.sarchCardShow"
                    :gutter="16">
                    <Col span="24">
                    <search-card :form="mainTable.searchForm"
                        :table-load-event="getPromotionTableRecords"
                        :table-search="mainTable.tableSearch"
                        :colSpan="4" />
                    </Col>
                </Row>
            </transition>

            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">客户优惠管理</span>
                    </div>
                    <div class="right-bar">
						<div v-if="$checkAccessArray(['B'])">
						<Button class="btns"
							size="small"
							shape="circle"
							icon="md-arrow-down"
							@click="onExport">导出</Button>
                        <Button class="btns"
                            size="small"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreate">新增</Button>
                        <Button class="btns"
                            size="small"
                            shape="circle"
                            type="warning"
                            icon="ios-add-circle-outline"
                            @click="onBatchCreate">批量新增</Button>
                        <Button class="btns"
                            size="small"
                            shape="circle"
                            type="info"
                            @click="onActive(1)">启用</Button>
                        <Button class="btns"
                            size="small"
                            shape="circle"
                            type="error"
                            @click="onActive(0)">停用</Button>
                        <Button class="btns"
                            size="small"
                            shape="circle"
                            type="info"
                            ghost
                            @click="onPublic(1)">公开</Button>
                        <Button class="btns"
                            size="small"
                            shape="circle"
                            type="error"
                            ghost
                            @click="onPublic(0)">不公开</Button>
						</div>
						<div>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
						</div>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table ref="promotionTable"
                    :columns="mainTable.columns"
                    :data="mainTable.data"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getPromotionTableRecords" />
                </Col>
            </Row>
        </Card>

        <Modal v-model="promotionForm.show"
            title="客户优惠信息"
            width="600">
            <Loading :isLoading="saveLoading" />
            <Form ref="promotionForm"
                :model="promotionForm"
                label-position="top">
                <Row :gutter="16">
                    <Col v-if="promotionForm.type === 'single'"
                        span="24">
                    <FormItem label="客户信息">
                        <Select v-model="promotionForm.promotionUserUuid"
                            filterable>
                            <Option v-for="item in userList"
                                :key="item.userExternalCustomerLoginUuid"
                                :value="item.userExternalCustomerLoginUuid">{{ item.userName + '-' +item.userExternalCustomerName + '-' + item.userExternalCustomerPhone }}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col v-else
                        span="24">
                    <FormItem label="客户信息">
                        <Select v-model="promotionForm.promotionUserUuids"
                            filterable
                            multiple>
                            <Option v-for="item in userList"
                                :key="item.userExternalCustomerLoginUuid"
                                :value="item.userExternalCustomerLoginUuid">{{ item.userName + '-' +item.userExternalCustomerName + '-' + item.userExternalCustomerPhone }}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="是否启用">
                        <RadioGroup v-model="promotionForm.promotionEnable">
                            <Radio :label="1">启用</Radio>
                            <Radio :label="0">停用</Radio>
                        </RadioGroup>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="是否公开">
                        <RadioGroup v-model="promotionForm.promotionPublic">
                            <Radio :label="1">公开</Radio>
                            <Radio :label="0">不公开</Radio>
                        </RadioGroup>
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <!-- <Col span="12">
                    <FormItem label="订购量">
                        <InputNumber v-model="promotionForm.promotionQuantityThreshold"
                            :min="0"
                            :active-change="false"
                            style="width:100%"></InputNumber>
                    </FormItem>
                    </Col> -->
                    <Col span="12">
                    <FormItem label="折扣比例(如九折=0.9)">
                        <InputNumber v-model="promotionForm.promotionQuantityDisount"
                            :min="0"
                            :active-change="false"
                            style="width:100%"></InputNumber>
                    </FormItem>
                    </Col>
					<Col span="12">
					<FormItem label="单价优惠(元)">
					    <InputNumber v-model="promotionForm.promotionValudeDiscount"
					        :min="0"
					        :active-change="false"
					        style="width:100%"></InputNumber>
					</FormItem>
					</Col>
                </Row>
                <Row :gutter="16">
                    <!-- <Col span="12">
                    <FormItem label="订购额(元)">
                        <InputNumber v-model="promotionForm.promotionValueThreshold"
                            :min="0"
                            :active-change="false"
                            style="width:100%"></InputNumber>
                    </FormItem>
                    </Col> -->
                    
                </Row>
                <Row :gutter="16">
                    <!-- <Col span="12">
                    <FormItem label="付定金比例(%)">
                        <InputNumber v-model="promotionForm.promotionDepositThreshold"
                            :min="0"
                            :active-change="false"
                            style="width:100%"></InputNumber>
                    </FormItem>
                    </Col> -->
                    <Col span="12">
                    <FormItem label="总价优惠(元)">
                        <InputNumber v-model="promotionForm.promotionDepositDiscount"
                            :min="0"
                            :active-change="false"
                            style="width:100%"></InputNumber>
                    </FormItem>
                    </Col>
                </Row>
				<!-- <Row :gutter="16">
				    <Col span="12">
				    <FormItem label="提前预订天数(天)">
				        <InputNumber v-model="promotionForm.bookAheadDays"
				            :min="0"
				            :active-change="false"
				            style="width:100%"></InputNumber>
				    </FormItem>
				    </Col>
				    <Col span="12">
				    <FormItem label="预订优惠(元)">
				        <InputNumber v-model="promotionForm.bookDiscount"
				            :min="0"
				            :active-change="false"
				            style="width:100%"></InputNumber>
				    </FormItem>
				    </Col>
				</Row>
 -->
            </Form>
            <div slot="footer">
                <Button type="primary"
                    @click="onSave" >确认</Button>
                <Button type="error"
                    @click="onCancel">取消</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import Loading from '@/components/loading/Loading.vue';
import { getUserPromotionList, savePromotion, getAllUserList, batchAddPromotion, batchActivePromotion, batchPublicPromotion } from '@/api/modules/system-management/seedFarm-management';
import { DOWNLOAD_SERVER } from '@/api/modules/files';
export default {
    name: 'PromotionList',
    components: {
        StandPaginationTable,
        SearchCard,
        Loading
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            innerSpin: false,
            userList:[],
            promotionForm: {
                type: 'single',
                show: false,
                promotionUuid: '',
                promotionUserUuid: '',
                promotionUserUuids: [],
                promotionQuantityThreshold: 0,
                promotionQuantityDisount: 0,
                promotionValueThreshold: 0,
                promotionValudeDiscount: 0,
                promotionDepositThreshold: 0,
                promotionDepositDiscount: 0,
                bookAheadDays: 0,
                bookDiscount: 0,
                promotionEnable: 0,
                promotionPublic: 0,
                promotionType:1
            },
            mainTable: {
                columns: [
                    { type: 'selection', width: 60, align: 'center' },
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '种苗场编号', key: 'seedFarmCode', align: 'center', excel: true },
                    { title: '种苗场名称', key: 'seedFarmName', align: 'center', excel: true },
                    { title: '会员号', key: 'userName', align: 'center', excel: true },
                    { title: '会员名称', key: 'userPersonName', align: 'center', excel: true },
                    //{ title: '订购量', key: 'promotionQuantityThreshold', align: 'center' , excel: true},
                    { title: '折扣比例', key: 'promotionQuantityDisount', align: 'center', excel: true },
                    //{ title: '订购额', key: 'promotionValueThreshold', align: 'center' , excel: true},
                    { title: '单价优惠', key: 'promotionValudeDiscount', align: 'center', excel: true },
                    // { title: '付定金比例(%)', key: 'promotionDepositThreshold', align: 'center', excel: true },
                    { title: '总价优惠', key: 'promotionDepositDiscount', align: 'center', excel: true },
                    // { title: '提前预订天数', key: 'bookAheadDays', align: 'center' },
                    //{ title: '预订优惠', key: 'bookDiscount', align: 'center', excel: true },
                    {
                        title: '是否启用', key: 'promotionEnable', align: 'center', excel: true,
                        render: (h, params) => {
                            let text = params.row.promotionEnable === 1 ? '是' : '否';
                            let color = params.row.promotionEnable === 1 ? '' : 'red';
                            return h('div', [
                                h('span', {
                                    style: {
                                        color: color
                                    }
                                }, text)
                            ]);
                        }
                    },
                    {
                        title: '是否公开', key: 'promotionPublic', align: 'center', excel: true,
                        render: (h, params) => {
                            let text = params.row.promotionPublic === 1 ? '是' : '否';
                            let color = params.row.promotionPublic === 1 ? '' : 'red';
                            return h('div', [
                                h('span', {
                                    style: {
                                        color: color
                                    }
                                }, text)
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onPromotionUpdate(params.row);
                                        }
                                    }
                                }, '编辑')]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '苗场信息', type: 'Input', value: '', name: 'concat(seedFarmCode, seedFarmName)', sql: 'like' },
                    { label: '会员信息', type: 'Input', value: '', name: 'concat(userName, userPersonName)', sql: 'like' },
                    {
                        label: '是否启用',
                        type: 'Select',
                        value: [],
                        name: 'promotionEnable',
                        sql: 'in',
                        options: [{ key: '启用', value: '1' }, { key: '停用', value: 0 }]
                    },
                    {
                        label: '是否公开',
                        type: 'Select',
                        value: [],
                        name: 'promotionPublic',
                        sql: 'in',
                        options: [{ key: '公开', value: '1' }, { key: '不公开', value: 0 }]
                    }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            productList: [],
            saveLoading:false
        };
    },
    mounted() {
        this.getUserList();
        this.getPromotionTableRecords();
    },
    methods: {
        onExport(){
            this.mainTable.tableSearch.excelExport.enable = true;
            this.mainTable.tableSearch.excelExport.columns = this.mainTable.columns
			    .filter(col => col.excel)
			    .map(col => {
			        return {
			            key: col.key,
			            title: col.title
			        };
			    });
            this.mainTable.loading = true;
            getUserPromotionList(this.mainTable.tableSearch).then(res => {
			    if (res.code === 0) {
			        if (res.code === 0) {
			            let url = DOWNLOAD_SERVER + res.data.exportFileName;
			            this.$downLoadFile(url);
			            // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
			        }
			    }
			    this.mainTable.loading = false;
            });
        },
        onPublic(type) {
            let selection = this.$refs.promotionTable.$refs.standPaginationTable.getSelection();
            if (selection.length === 0) {
                this.$Modal.error({
                    title: '未勾选记录'
                });
                return;
            }

            let data = {
                promotionUuids: selection.map(e => {
                    return e.promotionUuid;
                }),
                enable: type
            };
            this.innerSpin = true;
            batchPublicPromotion(data).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.getPromotionTableRecords();
                }
            });
        },
        onActive(type) {
            let selection = this.$refs.promotionTable.$refs.standPaginationTable.getSelection();
            if (selection.length === 0) {
                this.$Modal.error({
                    title: '未勾选记录'
                });
                return;
            }

            let data = {
                promotionUuids: selection.map(e => {
                    return e.promotionUuid;
                }),
                enable: type
            };
            this.innerSpin = true;
            batchActivePromotion(data).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.getPromotionTableRecords();
                }
            });
        },
        getUserList() {
            getAllUserList().then(res => {
                if (res.code === 0) {
                    this.userList = res.data.userExternalCustomerList;
                }
            });
        },
        getPromotionTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getUserPromotionList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        onBatchCreate() {
            this.promotionForm.type = 'multi';
            this.promotionForm.promotionUuid = '';
            this.promotionForm.promotionUserUuid = '';
            this.promotionForm.promotionQuantityThreshold = 0;
            this.promotionForm.promotionQuantityDisount = 0;
            this.promotionForm.promotionValueThreshold = 0;
            this.promotionForm.promotionValudeDiscount = 0;
            this.promotionForm.promotionDepositThreshold = 0;
            this.promotionForm.promotionDepositDiscount = 0;
            this.promotionForm.bookAheadDays = 0;
            this.promotionForm.bookDiscount = 0;
            this.promotionForm.promotionEnable = 1;
            this.promotionForm.promotionPublic = 1;
            this.promotionForm.show = true;
        },
        onCreate() {
            this.promotionForm.type = 'single';
            this.promotionForm.promotionUuid = '';
            this.promotionForm.promotionUserUuid = '';
            this.promotionForm.promotionQuantityThreshold = 0;
            this.promotionForm.promotionQuantityDisount = 0;
            this.promotionForm.promotionValueThreshold = 0;
            this.promotionForm.promotionValudeDiscount = 0;
            this.promotionForm.promotionDepositThreshold = 0;
            this.promotionForm.promotionDepositDiscount = 0;
            this.promotionForm.bookAheadDays = 0;
            this.promotionForm.bookDiscount = 0;
            this.promotionForm.promotionEnable = 1;
            this.promotionForm.promotionPublic = 1;
            this.promotionForm.show = true;
        },
        onCancel() {
            this.promotionForm.show = false;
        },
        onPromotionUpdate(row) {
            Object.assign(this.promotionForm, row);
            this.promotionForm.show = true;
        },
        onSave() {
            if (this.promotionForm.type === 'single') {
                this.promotionForm.bookAheadDays=0;
                this.promotionForm.bookDiscount=0;
                this.saveLoading=true;
                savePromotion(this.promotionForm).then(res => {
                    if (res.code === 0) {
                        this.saveLoading=false;
                        this.$Message.info('保存成功');
                        this.promotionForm.show = false;
                        this.getPromotionTableRecords();
                    }
                });
            }
            else {
                this.promotionForm.bookAheadDays=0;
                this.promotionForm.bookDiscount=0;
                this.saveLoading=true;
                batchAddPromotion(this.promotionForm).then(res => {
                    if (res.code === 0) {
                        this.saveLoading=false;
                        this.$Message.info('新增成功');
                        this.promotionForm.show = false;
                        this.getPromotionTableRecords();
                    }
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.form-button {
    margin-top: 5px;
}
</style>
